import TablePage from '@/found/components/table_page';
import Form from './form/index';
import scanDetails from './scan_details';

export default {
  name: 'table-component',
  extends: TablePage,
  components: { Form, scanDetails },
  data() {
    return {};
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.formName = 'Form';
        this.modalConfig.title = '详情';
        this.openFull();
        this.formConfig = {
          code: val.code,
          row,
        };
      }
      if (val.code === 'scan_details') {
        this.modalConfig.title = '扫码明细';
        this.formName = 'scanDetails';
        this.propsObjInData.row = row;
        // this.openDrawer();
        this.openFull();
      }
    },
  },
  created() {
    this.getConfigList('banquet_present_list');
  },

};
